export default __webpack_public_path__ + "static/media/down.7c39e843.svg";